import { cn } from '@/lib/utils';

type SubTab = 'properties' | 'contracts';

interface PropertiesSubNavProps {
  activeSubTab: SubTab;
  onSubTabChange: (tab: SubTab) => void;
}

const tabs: { key: SubTab; label: string }[] = [
  { key: 'properties', label: 'Propiedades' },
  { key: 'contracts', label: 'Contratos' },
];

const PropertiesSubNav = ({ activeSubTab, onSubTabChange }: PropertiesSubNavProps) => {
  return (
    <div className="border-b border-border">
      <nav className="flex gap-6" aria-label="Properties tabs">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => onSubTabChange(tab.key)}
            className={cn(
              'pb-3 text-sm font-medium transition-colors relative',
              activeSubTab === tab.key
                ? 'text-foreground'
                : 'text-muted-foreground hover:text-foreground'
            )}
          >
            {tab.label}
            {activeSubTab === tab.key && (
              <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary rounded-full" />
            )}
          </button>
        ))}
      </nav>
    </div>
  );
};

export default PropertiesSubNav;
